export function createApi(httpClient) {
  return {
    cjTracking
  };
  function cjTracking(params) {
    return httpClient.post('/tracking', params).then(r => {
      return r.data;
    });
  }
}